import React, { useState } from 'react';
import { Button, Tooltip, message } from 'antd';
import { ShareAltOutlined } from '@ant-design/icons';

interface Props {
    /** Lazy text builder — called only when user clicks */
    getText: () => string;
    disabled?: boolean;
    size?: 'small' | 'middle' | 'large';
    /** Override button label (default: "Share") */
    label?: string;
    type?: 'default' | 'primary' | 'text' | 'dashed' | 'link';
}

const ShareResultButton: React.FC<Props> = ({
    getText,
    disabled,
    size = 'small',
    label = 'Share',
    type = 'default',
}) => {
    const [loading, setLoading] = useState(false);

    const handleShare = async () => {
        const text = getText();
        if (!text) return;
        setLoading(true);
        try {
            if (typeof navigator.share === 'function') {
                try {
                    await navigator.share({ text });
                } catch (e: any) {
                    // AbortError means user cancelled — don't fall back or show error
                    if (e?.name !== 'AbortError') {
                        await navigator.clipboard.writeText(text);
                        message.success('Result copied to clipboard!');
                    }
                }
            } else {
                await navigator.clipboard.writeText(text);
                message.success('Result copied to clipboard!');
            }
        } catch {
            message.error('Could not copy result');
        }
        setLoading(false);
    };

    return (
        <Tooltip title={disabled ? 'Publish results first to share' : 'Share result as text'}>
            <Button
                size={size}
                type={type}
                icon={<ShareAltOutlined />}
                onClick={handleShare}
                loading={loading}
                disabled={disabled}
            >
                {label}
            </Button>
        </Tooltip>
    );
};

export default ShareResultButton;
